import { Skeleton } from "@mui/material";
import React from "react";
import "./SlotCardSkeleton.css";
export const SlotCardSkeleton = () => {
  return <Skeleton className="slot-card-skeleton"></Skeleton>;
};
